import { render } from "./ShoppingCartPage.vue?vue&type=template&id=63ef8a73"
import script from "./ShoppingCartPage.vue?vue&type=script&lang=js"
export * from "./ShoppingCartPage.vue?vue&type=script&lang=js"

import "./ShoppingCartPage.vue?vue&type=style&index=0&id=63ef8a73&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__